import * as React from 'react';

import Popover from 'components/popover/Popover';
import AndOr from 'components/and-or/AndOr';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import './discovery-content-search-logical.scss';

import type { AndOrOptions } from 'types';

applyTranslations(require('./discovery-content-search-logical.i18n.json'));

type Props = {
  searchTermsLogicalOperator: AndOrOptions,
  onUpdateSearchTermsLogical: (a: AndOrOptions) => void
};

const msgKey = 'discovery_content_search_logical';

class DiscoveryContentSearchLogical extends React.PureComponent<Props> {
  getPopoverText(type: AndOrOptions): string {
    return sanitizeGenericHtml(
      __t(`${msgKey}.tooltips.${type}_description`, {
        type: `<strong>${__t(`${msgKey}.labels.${type}`)}</strong>`
      })
    );
  }

  renderPopover(): React.ReactNode {
    return (
      <Popover showQuestionMark>
        <div className="discovery-content-search-logical__popover-content">
          <div
            dangerouslySetInnerHTML={{ __html: this.getPopoverText('and') }}
          />
          <div
            dangerouslySetInnerHTML={{ __html: this.getPopoverText('or') }}
          />
        </div>
      </Popover>
    );
  }

  renderAndOr(): React.ReactNode {
    const { searchTermsLogicalOperator, onUpdateSearchTermsLogical } = this.props;

    return (
      <div className="discovery-content-search-logical__andor">
        <AndOr
          name="search"
          selectedOption={searchTermsLogicalOperator}
          onSetOption={onUpdateSearchTermsLogical}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-search-logical">
        <div className="discovery-content-search-logical__label">
          <div className="discovery-content-search-logical__text">
            {__t(`${msgKey}.labels.search_keywords`)}
          </div>
          <div className="discovery-content-search-logical__popover">
            {this.renderPopover()}
          </div>
        </div>
        {this.renderAndOr()}
      </div>
    );
  }
}

export default DiscoveryContentSearchLogical;
